/* eslint-disable */
import _ from 'lodash';
import moment from 'moment';
import CommonUtils from 'utilities/common-utils';
import { FilterType } from 'utilities/enum-utils';
import { bundledDatesRangeOptions } from '@good/ui/templates';

/**
 * Resolves datePreset (e.g. 'this-week') to actual dates for API requests.
 * Preserves datePreset in the filter for display/save; replaces values with current date range.
 */
export function resolveDatePresetInFilter(filter: Record<string, unknown>): Record<string, unknown> {
  const datePreset = filter.datePreset as string | undefined;
  if (!datePreset || filter.filter !== FilterType.DATE_RANGE) {
    return filter;
  }
  const presetOption = bundledDatesRangeOptions[datePreset as keyof typeof bundledDatesRangeOptions];
  if (!presetOption) {
    return filter;
  }
  if (datePreset === 'all') {
    return { ...filter, values: [] };
  }
  if (!presetOption.range?.[0] || !presetOption.range?.[1]) {
    return filter;
  }
  return { ...filter, values: [moment(presetOption.range[0]), moment(presetOption.range[1])] };
}

export const formatFilters = (filters) => {
  return filters
    .filter((filter) => !_.isEmpty(filter))
    .map((filter) => {
      if (_.isUndefined(filter.filter)) {
        const [[key, value]] = Object.entries(filter);
        return {
          filter: key,
          values: value || [],
          selectionLabel: !_.isEmpty(value)
            ? key === FilterType.DATE_RANGE
              ? CommonUtils.getFilterText(FilterType.DATE_RANGE, [moment(value[0]), moment(value[1])])
              : CommonUtils.getFilterText(key, value)
            : CommonUtils.getFilterSettings(key).fullSelectionName,
        };
      }
      return resolveDatePresetInFilter(filter);
    });
};
